"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeNormal = exports.CTGPulseSpeed = exports.CTGScoreSpeed = exports.CTGConstantSpeed = exports.CTGNoSpeed = exports.CTGISpeed = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const CTGGameMode_1 = require("./CTGGameMode");
class CTGISpeed {
}
exports.CTGISpeed = CTGISpeed;
class CTGNoSpeed extends CTGISpeed {
    constructor() {
        super();
    }
    compute_delta(now, previous, delta, difficulty, score) {
        return 0;
    }
}
exports.CTGNoSpeed = CTGNoSpeed;
class CTGConstantSpeed extends CTGISpeed {
    constructor(pixels_per_second) {
        super();
        this.pixels_per_second = pixels_per_second;
    }
    compute_delta(now, previous, delta, difficulty, score) {
        return this.pixels_per_second * (1 + difficulty) * delta;
    }
}
exports.CTGConstantSpeed = CTGConstantSpeed;
class CTGScoreSpeed extends CTGISpeed {
    constructor(base_speed, pixels_per_score) {
        super();
        this.base_speed = base_speed;
        this.pixels_per_score = pixels_per_score;
    }
    compute_delta(now, previous, delta, difficulty, score) {
        return Math.max(this.base_speed, this.base_speed + score * this.pixels_per_score) * delta;
    }
}
exports.CTGScoreSpeed = CTGScoreSpeed;
class CTGPulseSpeed extends CTGISpeed {
    constructor(base_pixels_per_second, amplitude, period) {
        super();
        this.base_pixels_per_second = base_pixels_per_second;
        this.amplitude = amplitude;
        this.period = period;
        this._period_mult = (2 * Math.PI) / period;
    }
    compute_delta(now, previous, delta, difficulty, score) {
        // This is theoretically driven by a cosine wave centered at a y of base_pixels_per_second.
        // As a result, we're computing based on the integral of that function.
        const cos_portion = this.amplitude * (Math.sin(this._period_mult * now + this.amplitude / 2) - Math.sin(this._period_mult * previous + this.amplitude / 2)) / this._period_mult;
        const linear_portion = this.base_pixels_per_second * delta;
        return (cos_portion + linear_portion) * (1 + difficulty);
    }
}
exports.CTGPulseSpeed = CTGPulseSpeed;
class CTGGameModeNormal extends CTGGameMode_1.CTGGameMode {
    constructor(auto_scroll, generator, starting_rows, speed, animators = null, score_to_win, horizontal = false) {
        super(animators);
        this.auto_scroll = auto_scroll;
        this.generator = generator;
        this.win_on_time_out = true;
        this.speed = speed;
        this.total_rows = 5;
        this.starting_rows = Math.min(this.total_rows, starting_rows);
        this.rows = [];
        this.row_distance = this.spacing();
        this.score_to_win = score_to_win;
        this.horizontal = horizontal;
    }
    reset() {
        super.reset();
        this.rows = [];
        this.current_offset = 0;
    }
    on_start(scene, rand, difficulty) {
        super.on_start(scene, rand, difficulty);
        let total_rows = this.speed.compute_delta(this.get_time_limit(this.difficulty) / 1000, 0, this.get_time_limit(this.difficulty) / 1000, difficulty, 0) / this.spacing();
        this.generator.start(rand, total_rows);
    }
    generate_initial_cards(rand, difficulty) {
        let specs = [];
        for (let y = 0; y < this.total_rows; y++) {
            if (y >= this.total_rows - this.starting_rows) {
                let cards = this.generate_row(rand, y, difficulty);
                for (let i = 0; i < cards.length; i++) {
                    if (cards[i] == null)
                        continue;
                    specs.push(cards[i]);
                }
                this.rows.push(cards);
            }
            else {
                this.rows.push([]);
            }
        }
        return specs;
    }
    generate_row(rand, y, difficulty) {
        let row = this.generator.getRow(rand, 4);
        for (let i = 0; i < row.length; i++) {
            if (row[i] == null)
                continue;
            if (this.horizontal) {
                // 3 almost certainly isn't a contant, which might break
                // any future horizontal game modes. There's probably a bug here.
                row[i].x = this.fixed_x_position(3 - y);
                row[i].y = this.fixed_y_position(i);
                row[i].rot = 0;
            }
            else {
                row[i].x = this.fixed_x_position(i);
                row[i].y = this.fixed_y_position(y);
                row[i].rot = 0;
            }
        }
        return row;
    }
    card_tapped(card) {
        if (card.tap_requirement == CTGCard_1.CTGTapRequirement.Dont) {
            this.lose([card]);
        }
        else {
            card.destroy(true);
            if (this.score_to_win) {
                this.set_score(this.score + 1, (this.score + 1) / this.score_to_win);
                if (this.score == this.score_to_win) {
                    this.win();
                }
            }
        }
    }
    card_destroyed(card) {
    }
    row_off_screen(row) {
        let lose_cards = [];
        for (let card of row) {
            if (card == null)
                continue;
            if (card.destroyed)
                continue;
            if (card.tap_requirement == CTGCard_1.CTGTapRequirement.Must) {
                lose_cards.push(card);
                continue;
            }
            card.destroy(false);
        }
        ;
        if (lose_cards.length > 0) {
            this.lose(lose_cards);
        }
    }
    cards_generated(cards) { }
    time_ran_out() {
        this.win();
    }
    add_row() {
        let row = this.generate_row(this.rand, this.rows.length, this.difficulty);
        this.rows.push(row);
        row = row.filter(x => x != null);
        this.cards_added(row, true);
        this.emitEvent(CTGGameMode_1.CTGGameMode.EVENT_ADD_CARDS, { cards: row });
    }
    update_game(scene, now, delta, difficulty, mx, my, mdown) {
        if (!this.auto_scroll)
            return;
        let new_time = now - this.start_time;
        if (!this.score_to_win) {
            this.set_score(new_time, new_time / CTGGameMode_1.CTGGameMode.TIME_LIMIT);
        }
        const move_delta = this.speed.compute_delta(new_time / 1000, Math.max(0, new_time - delta) / 1000, delta / 1000, difficulty, this.score);
        this.current_offset += move_delta;
        if (this.current_offset > this.row_distance) {
            let row = this.rows.shift();
            this.row_off_screen(row);
            this.add_row();
            this.current_offset -= this.row_distance;
        }
        for (let i = 0; i < this.rows.length; i++) {
            let row = this.rows[i];
            if (this.horizontal) {
                // 3 almost certainly isn't a contant, which might break
                // any future horizontal game modes. There's probably a bug here.
                let x = this.fixed_x_position(3 - i) + this.current_offset;
                row.forEach(card => {
                    if (card != null)
                        card.move(x, card.y);
                });
            }
            else {
                let y = this.fixed_y_position(i) + this.current_offset;
                row.forEach(card => {
                    if (card != null)
                        card.move(card.x, y);
                });
            }
        }
    }
}
exports.CTGGameModeNormal = CTGGameModeNormal;
